/* MD Solutions · Größenfinder. Daten: Dr. Goos-Suprema Größentabellen und Längenempfehlung. */
(function () {
  "use strict";
  var U = { names: ["XS", "S", "M", "L", "XL", "XXL", "3XL"], codes: ["00", "02", "04", "06", "08", "10", "13"],
    brust: [82, 93, 104, 115, 126, 137, 148], taille: [73, 85, 96, 107, 117, 128, 139], hueft: [82, 93, 104, 114, 126, 136, 147] };
  var A = { names: ["XXS", "XS", "XS+", "S", "S+", "M", "M+", "L", "L+", "XL", "XL+", "2XL", "3XL"],
    codes: ["21", "00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "13"],
    brust: [87, 90, 93, 97, 100, 104, 111, 117, 124, 130, 137, 145, 154], taille: [79, 79, 81, 84, 87, 91, 97, 103, 109, 115, 121, 129, 137],
    hueft: [93, 96, 99, 103, 107, 111, 116, 122, 127, 133, 139, 145, 152] };
  /* Körpergröße (von, bis) -> Länge in cm: Schürze/Mantel, Rock */
  var LEN = [[145, 155, 90, 55], [156, 165, 100, 60], [166, 175, 110, 65], [176, 185, 120, 70], [186, 195, 130, 75]];
  var KEYS = { brust: "brust", taille: "taille", hueft: "hueft" };

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function pick(max, v) { for (var i = 0; i < max.length; i++) { if (v <= max[i]) return i; } return -1; }

  function init(root) {
    var type = root.getAttribute("data-mdx-sf"), set = type === "amazone" ? A : U;
    var out = root.querySelector("[data-sf-result]"), inputs = {};
    [].forEach.call(root.querySelectorAll("[data-sf]"), function (el) { inputs[el.getAttribute("data-sf")] = el; });
    var wanted = type === "skirt" ? ["hueft"] : ["brust", "taille", "hueft"], tracked = false;

    function val(k) { var el = inputs[k === "hueft" ? "huefte" : k]; if (!el || el.value === "") return null; var n = parseFloat(String(el.value).replace(",", ".")); return isFinite(n) && n > 0 ? n : null; }

    function render() {
      var vals = {}, filled = 0, idx = -1, over = false, edge = false, driver = "";
      var idxs = {};
      wanted.forEach(function (k) {
        var v = val(k); if (v === null) return; vals[k] = v; filled++;
        var i = pick(set[k], v);
        if (i < 0) { over = true; return; }
        idxs[k] = i;
        if (set[k][i] - v < 1 && set[k][i] - v >= 0) edge = true;
        if (i > idx) { idx = i; driver = k; }
      });
      var h = val("hoehe");
      if (filled === 0 && h === null) { out.hidden = true; out.innerHTML = ""; return; }
      var html = "", lenRec = null;
      /* AMAZONE Weste (Damenschnitt): weicht die Taille um 2 oder mehr Größen von der Brust ab, passt eine andere Weste besser */
      if (type === "amazone" && idxs.brust !== undefined && idxs.taille !== undefined && Math.abs(idxs.taille - idxs.brust) >= 2) {
        out.innerHTML = '<p class="mdx-sf__note"><strong>Die AMAZONE Weste passt bei diesen Maßen nicht optimal.</strong> Ihre Taille liegt ' + (idxs.taille > idxs.brust ? "deutlich über" : "deutlich unter") + ' der Größe, die zur Brust passt (Brust: ' + esc(set.names[idxs.brust]) + ', Taille: ' + esc(set.names[idxs.taille]) + '). Wir empfehlen eine unserer anderen Westen, zum Beispiel die <a href="/products/pro-pk">Triplex-Weste</a>, oder fragen Sie uns: <a href="/pages/kontaktanfrage">Beratung anfragen</a></p>';
        out.hidden = false;
        if (!tracked) { tracked = true; (window.dataLayer = window.dataLayer || []).push({ event: "groessenfinder_ergebnis", finder_typ: type, groesse: "andere_weste" }); }
        return;
      }
      if (over) {
        html += '<p class="mdx-sf__note"><strong>Ihre Maße liegen über unserem Standardraster.</strong> Wir fertigen gern nach Maß: <a href="/pages/kontaktanfrage">Maßanfertigung anfragen</a></p>';
      } else if (filled > 0) {
        html += '<div class="mdx-sf__row"><span class="mdx-sf__label">Größe</span><span class="mdx-sf__value">' + esc(set.names[idx]) + '<small>Code ' + esc(set.codes[idx]) + '</small></span></div>';
      }
      if (h !== null && (type === "apron" || type === "skirt")) {
        var l = null;
        for (var j = 0; j < LEN.length; j++) { if (h >= LEN[j][0] && h <= LEN[j][1]) l = LEN[j][type === "apron" ? 2 : 3]; }
        lenRec = l;
        if (l !== null) html += '<div class="mdx-sf__row"><span class="mdx-sf__label">Länge</span><span class="mdx-sf__value">' + l + ' cm<small>Code ' + (l < 100 ? "0" + l : l) + '</small></span></div>';
        else html += '<p class="mdx-sf__note"><strong>Für Ihre Körpergröße empfehlen wir eine persönliche Beratung.</strong> Sonderlängen sind auf Anfrage möglich: <a href="/pages/kontaktanfrage">Beratung anfragen</a></p>';
      }
      if (!over && filled > 0) {
        if (filled < wanted.length) html += '<p class="mdx-sf__note">Für eine sichere Empfehlung geben Sie bitte alle Maße ein.</p>';
        else if (edge) html += '<p class="mdx-sf__note"><strong>Ein Wert liegt knapp an der Grenze.</strong> Im Zweifel wählen Sie die nächstgrößere Größe' + (idx < set.names.length - 1 ? " (" + esc(set.names[idx + 1]) + ")" : "") + '.</p>';
        else if (wanted.length > 1) html += '<p class="mdx-sf__note">Maßgeblich ist das Maß mit der größten Größe (hier: ' + ({ brust: "Brust", taille: "Taille", hueft: "Hüfte" })[driver] + ').</p>';
        if (type === "apron" || type === "skirt") html += '<p class="mdx-sf__note">Die Länge reicht bis unter das Knie, so wie es die Norm DIN EN 61331-3 verlangt.</p>';
      }
      out.innerHTML = html; out.hidden = false;
      /* Ergebnis an den Produktkonfigurator weitergeben (Größe nur bei vollständigen Maßen) */
      document.dispatchEvent(new CustomEvent("mdx:sizefinder", { detail: { type: type, size: (!over && filled === wanted.length) ? set.names[idx] : null, length: lenRec } }));
      if (!tracked && !over && filled === wanted.length) {
        tracked = true;
        (window.dataLayer = window.dataLayer || []).push({ event: "groessenfinder_ergebnis", finder_typ: type, groesse: set.names[idx] });
      }
    }

    Object.keys(inputs).forEach(function (k) { inputs[k].addEventListener("input", render); });
  }

  function boot() { [].forEach.call(document.querySelectorAll("[data-mdx-sf]"), function (r) { if (!r.__sf) { r.__sf = 1; init(r); } }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
